import type { Command } from '../../../../common/types';

export const sortCommands = (commands: Command[]): Command[] =>
	commands
		.sort((a, b) => (a.priority || 0) - (b.priority || 0))
		.map((command, priority) => ({
			...command,
			priority,
		}));
